<div class="holder">
  <router-outlet></router-outlet>
</div>